<template>
  <div class="dashboard">
    <div class='row'>
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <div class="d-flex justify-content-between">
              <h2 class="card-title">Dashboard Lote</h2>
            </div>
          </div>
          <div class="card-body" v-if="user !== null && comparacionRoles">
            <div class="position-relative">
              <div class="row">
                <div class="col-sm-3"><b>Lote:</b></div>
                <div class="col-sm-4">
                <b-form-select v-model="selectedLote" :options="optionsLote" class="mb-3">
                  <template v-slot:first>
                    <option :value="null" disabled>-- Please select an option --</option>
                  </template>
                </b-form-select>
                </div>
                <div class="col-sm-2"><b>Año:</b></div>
                <div class="col-sm-3">
                  <b-form-select v-model="selectedYear" :options="optionsYear" class="mb-3">
                    <template v-slot:first>
                      <option :value="null" disabled>-- Please select an option --</option>
                    </template>
                  </b-form-select>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="card-header">
                    <div class="d-flex justify-content-between">
                      <h3 class="card-title">ACUMULADOS POR {{selectedLote}}</h3>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="position-relative col-lg-12">
                        <bar-chart :chart-data="chartdata" :options="chartoptions" :height="400"></bar-chart>
                      </div>
                    </div>
                    <div class="row">
                      <!-- table -->
                      <!--<b-table striped hover :items="items" :fields="fields" style="p"></b-table>-->
                      <table v-if = "selectedLote && selectedYear" class="table table-bordered">
                        <thead class="thead-light">
                          <tr>
                            <th scope="col"></th>
                            <th scope="col" v-for="disp in lote[selectedLote].displays" v-bind:key="disp">{{disp}}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(nivelx,i) in nivel" v-bind:key="i">
                            <th scope="row">{{items[i].nivel}}</th>
                            <td v-for="(elem,j) in nivel[4-i]" v-bind:key="i + '_' + j">{{elem}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Base from './Base.vue'
import Vue from 'vue'
import { mapState } from 'vuex'
import BarChart from './chart/BarChart.vue'
export default {
  extends: Base,
  name: 'dashboardLote',
  components: {
    BarChart
  },
  data () {
    return {
      items: [{ nivel: 'Alto' }, { nivel: 'Moderadamente Alto' }, { nivel: 'Moderado' }, { nivel: 'Bajo' }, { nivel: 'Muy bajo' }],
      nivel: [],
      llamada: false,
      dashboardData: [],
      optionsLote: [
        {
          value: 'l88',
          text: 'LOTE 88/56'
        },
        {
          value: 'l57',
          text: 'LOTE 57'
        }
      ],
      selectedLote: null,
      selectedYear: null,
      optionsYear: [],
      chartdata: {
        labels: [],
        type: 'bar',
        datasets: [{
          label: 'Muy bajo',
          backgroundColor: '#D3D3D3',
          data: []
        }, {
          label: 'Bajo',
          backgroundColor: '#D3D3D3',
          data: []
        }, {
          label: 'Moderado',
          backgroundColor: '#D3D3D3',
          data: []
        }, {
          label: 'Moderadamente Alto',
          backgroundColor: '#D3D3D3',
          data: []
        }, {
          label: 'Alto',
          backgroundColor: '#D3D3D3',
          data: []
        }
        ]
      },
      chartoptions: {
        scales: {
          xAxes: [{
            stacked: true,
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true
            },
            type: 'linear'
          }]
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: { position: 'bottom' }
      },
      lote: {
        l88: { displays: ['MLV - Cash 1', 'Cash 1 - Cash 3', 'Nuevo Cashiriari', 'Mipaya - NM', 'NM - Pag A', 'Pagoreni', 'MLV - SM1', 'SM1 - SM3'], values: ['cashiriari1', 'cashiriari2', 'cashiriari3', 'mipaya1', 'mipaya2', 'pagoreni', 'sanmartin1', 'sanmartin2'] },
        l57: { displays: ['U200', 'U210', 'U220', 'U600'], values: ['u200', 'u210', 'u220', 'u600'] }
      }
    }
  },
  watch: {
    selectedLote (to, from) {
      this.filterData()
    },
    selectedYear (to, from) {
      this.filterData()
    }
  },
  computed: {
    ...mapState([
      'user',
      'entities'
    ]),
    comparacionRoles () {
      if (!this.user.roles[0].startsWith('inspection_0') && !this.user.roles[0].startsWith('inspection_1')) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    filterData () {
      var obj = this
      var nivel = []
      var lote = this.lote
      if (this.selectedLote && this.selectedYear) {
        for (let i = 0; i < 5; i++) {
          nivel.push([])
          for (let j = 0; j < lote[this.selectedLote].displays.length; j++) {
            nivel[i].push(0)
          }
        }
        for (let i in obj.dashboardData) {
          if (obj.dashboardData[i].key[0] === this.selectedYear &&
            (lote[this.selectedLote].values).includes(obj.dashboardData[i].key[1])) {
            var index = null
            index = lote[this.selectedLote].values.indexOf(obj.dashboardData[i].key[1])
            if (index !== null) {
              nivel[obj.dashboardData[i].key[2] - 1][index] = obj.dashboardData[i].value
            }
          }
        }
      }
      obj.fields = lote[this.selectedLote].displays
      // sebas
      /* obj.$set(obj, 'items', [
        {nivel: 'Muy alto'},
        {nivel: 'Alto', Cashiriari: nivel[1][3], Mipaya: nivel[2][3]},
        {nivel: 'Medio'},
        {nivel: 'Bajo'},
        {nivel: 'Muy bajo'}
      ]) */
      obj.$set(obj, 'nivel', nivel)
      obj.$set(obj, 'chartdata', {
        labels: lote[this.selectedLote].displays,
        type: 'bar',
        datasets: [{
          label: 'Muy bajo',
          backgroundColor: '#00B050',
          data: nivel[0]
        }, {
          label: 'Bajo',
          backgroundColor: '#92D050',
          data: nivel[1]
        }, {
          label: 'Moderado',
          backgroundColor: '#FFFF00',
          data: nivel[2]
        }, {
          label: 'Moderadamente Alto',
          backgroundColor: '#FFBF00',
          data: nivel[3]
        },
        {
          label: 'Alto',
          backgroundColor: '#FF0000',
          data: nivel[4]
        }]
      })
    },
    readyMethod () {
      this.loadData()
    },
    loadData () {
      var obj = this
      if (!obj.llamada) {
        obj.llamada = true
        this.dbconfig.get('config').then(function (config) {
          // var url = config.server + '/' + obj.$route.params.json + '/_design/app/_list/permission/permission'
          var url = obj.db.name + '/_design/app/_view/acumulados'
          Vue.http.get(url, {
            withCredentials: true,
            params: {
              reduce: true,
              group: true
            }
          }).then(
            function (msj) {
              obj.dashboardData = msj.body.rows
              for (let i in obj.dashboardData) {
                if (!(obj.optionsYear.includes(obj.dashboardData[i].key[0]))) obj.optionsYear.push(obj.dashboardData[i].key[0])
              }
              obj.optionsYear.reverse()
            },
            function (err) {
              console.log(err)
              if ('message' in err) {
                obj.msg = err.message
              } else {
                obj.msg = err.toString()
              }
              obj.setMessage('DashboardLote: ' + JSON.stringify(err))
            }
          )
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table th, .table td {
    padding: 0.75rem;
    vertical-align: middle;
    text-align: center;
    border-top: 1px solid #dee2e6;
}
</style>
